import React from 'react';
import { Home } from '../containers/Home';
const Homepage = () => <Home data-sentry-element="Home" data-sentry-component="Homepage" data-sentry-source-file="index.tsx" />;
export default Homepage;